import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { DataGridPro, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro';
import { formatPhone } from '../../../../common/utils';


const LeadTracker = ( { aid, meta, user, viewing, canExport, opps, contacts, loans, start, end } ) => {
    const [ rows, setRows ] = useState( [] );
    const [ gridReady, setGridReady ] = useState( false );
    const [ cols, setCols ] = useState( [] );

    const toolbar = () => {
        return(
            <GridToolbarContainer>
                <Container fluid className='p-0'>
                    <Row className='p-0 align-items-center w-100'>
                        <Col></Col>
                        {
                            ( canExport ) ? (
                                <Col xs='auto' className='pe-3 text-right'>
                                    <GridToolbarExport />
                                </Col>
                            ) : (
                                null
                            )
                        }
                    </Row>
                </Container>
            </GridToolbarContainer>
        )
    }

    const formatName = useCallback( ( cid ) => {
        const r = contacts[cid]; // cl.find( f => f.cid === cid );
        return ( r ) ? `${r.firstname} ${r.lastname}` : null;
    }, [ contacts ] );

    useEffect( () => {
        let rows = [];
        
        const sd = new Date( start + 'T12:00:00.000' );
        const ed = new Date( end + 'T12:00:00.000' );
        
        if ( opps ) {
            Object.keys( opps ).forEach( loid => {
                const lo = opps[loid];
                if ( !viewing.includes( lo.aid ) ) {
                    return;
                }
                
                if ( lo.oppDate ) {
                    const od = new Date( lo.oppDate + 'T12:00:00.000' );
                    if ( od.getTime() >= sd.getTime() && od.getTime() <= ed.getTime() ) {
                        if ( lo.relationships?.length ) {
                            const cid = lo.relationships[0].cid;
                            const lid = lo.relationships[0].lid;
                            const c = contacts[cid];
                            const l = loans[lid] || {};
                            if ( c ) {
                                rows.push( {
                                    ...c,
                                    ...l,
                                    ...lo,
                                    id: lo.loid
                                } );
                            } else {
                                console.log( 'Aaccckkkk - no contact for cid: ' + cid );
                            }
                        } else {
                            console.log( 'Aaccckkk - no relationships for opp: ', lo );
                        }
                    }
                }
            } );
        }
        rows.sort( ( a, b ) => {
            const ad = new Date( a.oppDate );
            const bd = new Date( b.oppDate );
            return ad.getTime() - bd.getTime();
        } );
        rows.forEach( ( r, idx ) => r['rank'] = idx + 1 );

        console.log( rows );
        setRows( rows );
    }, [ opps, contacts, start, end, viewing ] );

    useEffect( () => {
        if ( !gridReady ) {
            let cols = [
                { field: 'rank', headerName: '', width: 40, type: 'number' },
                { field: 'cname', headerName: 'Contact', width: 175, renderCell: ( { row } ) => (
                  <Link to={`/contact/${row.cid}`}>{row.firstname} {row.lastname}</Link>
                ), valueGetter: ( { row } ) => ( `${row.firstname} ${row.lastname}` ) },
                { field: 'oppDate', headerName: 'Lead Date', type: 'date', width: 100, valueFormatter: ( { value } ) => {
                    let d = ( value ) ? new Date( value ) : null;
                    if ( d ) {
                        d.setDate( d.getDate() + 1 );
                    }
                    return ( d ) ? d.toLocaleDateString() : null;
                }, valueGetter: ( { value } ) => value && new Date( value ) },
                { field: 'name', headerName: 'Opp Description', width: 200 },
                { field: 'purpose', headerName: 'Purpose', width: 150 },
                { field: 'status', headerName: 'Status', width: 175 },
                { field: 'source', headerName: 'Source', width: 175 },
                { field: 'referredById', headerName: 'Referred By', width: 125, renderCell: ( { row } ) => (
                    <Link to={`/contact/${row.referredById}`}>{ formatName( row.referredById ) }</Link>
                  ), valueGetter: ( { row } ) => formatName( row.referredById ) },
                { field: 'phone', headerName: 'Phone', width: 125, renderCell: ( { value } ) => (
                  <a href={`tel:${value}`}>{formatPhone( value )}</a>
                ) },
                { field: 'phoneMobile', headerName: 'Mobile Phone', width: 125, renderCell: ( { value } ) => (
                  <a href={`tel:${value}`}>{formatPhone( value )}</a>
                ) },
                { field: 'phoneHome', headerName: 'Home Phone', width: 125, renderCell: ( { value } ) => (
                  <a href={`tel:${value}`}>{formatPhone( value )}</a>
                ) },
                { field: 'email', headerName: 'Email', width: 250, renderCell: ( { value } ) => (
                  <a href={`mailto:${value}`}>{value}</a>
                ) },
                { field: 'birthday', headerName: 'Birthday', type: 'date', width: 125, valueFormatter: ( { value } ) => value && new Date( value ).toLocaleDateString(), valueGetter: ( { value } ) => value && new Date( value ) },
                { field: 'notesInternal', headerName: 'Internal Notes', width: 400 },
                { field: 'intakePurchInitialCall', headerName: 'Intake Call', width: 150 },
                { field: 'paCall', headerName: 'PA Call', width: 150 },
                { field: 'autoComms', headerName: 'Auto Comms', width: 150 },
                { field: 'notesPublic', headerName: 'Public Remarks', width: 400, renderCell: ( { value } ) => {
                    if ( !value || !value.length ) {
                        return '';
                    }
                    return <div dangerouslySetInnerHTML={ { __html: value } } />;
                } }
            ];

            setCols( cols );
            setGridReady( true );
        }
    }, [ aid, gridReady, formatName ] );

    return (
        <Container fluid>
            <Row>
                <Col className='p-2'>
                    <Row>
                        <Col>
                            Lead Tracker
                        </Col>
                    </Row>
                    <Row>
                        <Col className='overflow-auto' style={ { height: '500px' } }>
                        {
                            ( gridReady ) ? (
                                <DataGridPro
                                    rows={ rows }
                                    columns={ cols }
                                    disableSelectionOnClick
                                    getRowHeight={ ( row ) => { 
                                        if ( aid !== 'AustinLampson' && ( ( row.model.notesInternal && row.model.notesInternal.length >= 65 ) || ( row.model.notesPublic && row.model.notesPublic.length >= 65 ) ) ) {
                                            return 'auto';
                                        }
                                        return 40; 
                                    } }
                                    slots={ { toolbar: toolbar } }
                                    initialState={ { pinnedColumns: { left: [ 'rank', 'cname' ] } } }
                                />
                            ) : (
                                null
                            )
                        }
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}

const mapProps = ( state ) =>( {
    aid: state.user.aid,
    meta: state.user.meta,
    user: state.user,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    opps: state.leadopps.byId,
    contacts: state.contacts.byId,
    loans: state.loans.byId,
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( LeadTracker );